import { Tab, TabProps } from '@mui/material'

interface MolsonTabProps extends TabProps {
  dataTestId?: string
}

export const MolsonTab = ({ dataTestId, ...props }: MolsonTabProps) => {
  return <Tab data-testid={dataTestId} {...props} />
}
